import { Component, Input } from '@angular/core';
import { CONSTANT } from '@bst-frontend/shared';

@Component({
  selector: 'bst-frontend-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css'],
})
export class OrderDetailsComponent {
  @Input() orderDetails: any;
  orderType: any = CONSTANT.orderType;
}
